import styled from 'styled-components';

import { getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const PriceElement = styled.span`
    font-size: ${getPurpurTypography('scale100')};
`;

export const OldPriceElement = styled.del`
    font-size: ${getPurpurTypography('scale75')};
`;
